export default function AccordionHandler() {
    const elements = document.querySelectorAll('[data-accordion-toggle]');

    if (elements) {
        elements.forEach((el) => {
            el.addEventListener('click', () => {
                const content = el.parentElement.querySelector('[data-accordion-content]');

                if (content) {
                    const activeContent = document.querySelector('[data-accordion].active');
                    if (activeContent && activeContent) activeContent.classList.remove('active');
                    if (activeContent !== el.parentElement) el.parentNode.classList.add('active');
                }
            });

            el.addEventListener('mouseenter', () => {
                el.parentElement.classList.add('hover');
                el.parentElement.classList.remove('sibling');

                if (el.parentElement.nextElementSibling)
                el.parentElement.nextElementSibling.classList.add('sibling');

                if (el.parentElement.previousElementSibling)
                el.parentElement.previousElementSibling.classList.add('sibling');
            });

            el.addEventListener('mouseleave', e => {
                el.parentElement.classList.remove('hover');

                if (el.parentElement.nextElementSibling)
                el.parentElement.nextElementSibling.classList.remove('sibling');

                if (el.parentElement.previousElementSibling)
                el.parentElement.previousElementSibling.classList.remove('sibling');
            });
        });
    }
}
  